<div class="d-flex">

    <div class="country-picker">
        <button class="country-code-picker cursor-pointer" mat-button [matMenuTriggerFor]="menu">

            <div class="d-flex align-items-center">

                <span class="country-flag">
                    <img [src]="selectedCountry?.flagUrl" id="shown-flag" alt="">
                </span>
                <span class="d-inline-block">
                    <p class="mb-0">+{{selectedCountry?.code}}</p>
                </span>
                <span class="d-inline-block">
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </span>

            </div>

        </button>

        <mat-menu class="num-picker" #menu="matMenu">
            <div class="menu-search">
                <div class="position-relative search-area-width">
                    <i class="fa fa-search position-absolute search-icon-btn"></i>
                    <input type="text" class="search-input-from-list" [(ngModel)]="searchTerm"
                        (ngModelChange)="filterCountries()" (click)="stopPropagation($event)"
                        placeholder="Search country">
                          <div class="cursor-pointer position-absolute search-cross-icon" *ngIf="searchTerm"
                        (click)="stopPropagation($event); removeSearch()">
                        <svg width="16" height="16" viewBox="0 0 649 649" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="325" cy="325" r="300" fill="#B7B7B7" fill-opacity="0.57" />
                            <path
                                d="M324.762 629.524C493.077 629.524 629.524 493.077 629.524 324.762C629.524 156.447 493.077 20 324.762 20C156.447 20 20 156.447 20 324.762C20 493.077 156.447 629.524 324.762 629.524Z"
                                fill="#B7B7B7" fill-opacity="0.57" stroke="white" stroke-width="38.0952"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M210.476 210.476L439.048 439.048Z"
                                fill="#B7B7B7" fill-opacity="0.57" />
                            <path d="M210.476 210.476L439.048 439.048" stroke="white" stroke-width="38.0952"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M439.048 210.476L210.476 439.048Z"
                                fill="#B7B7B7" fill-opacity="0.57" />
                            <path d="M439.048 210.476L210.476 439.048" stroke="white" stroke-width="38.0952"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>

            <ul class="m-0 p-0 items-ul items-list-width  position-relative">

                <li class="list-down sku-list" *ngIf="filteredCountriesList?.length > 0">

                    <div class="country-flag mx-0" mat-menu-item *ngFor="let country of filteredCountriesList"
                        (click)="selectKinCountry(country)">
                        <img [src]="country?.flagUrl" class="country-flag menu-flag" alt="">
                        <p class="mb-0 d-inline-block menu-name">{{country?.country + ' +' + country?.code}}</p>
                    </div>
                </li>
                
                <li class="list-down sku-list " *ngIf="filteredCountriesList?.length < 1">
                    <div class="country-flag mx-0" mat-menu-item>
                        <p class="mb-0 d-inline-block menu-name text-center">No country code found.</p>
                    </div>

                </li>
            </ul>

        </mat-menu>
    </div>

</div>